const decideThumb = option => {
  if (option.thumb) {
    return window.GLASSON_CONFIG.STORAGE + option.thumb;
  } else if (option.texture) {
    return window.GLASSON_CONFIG.STORAGE + option.texture;
  } else if (option.colors && option.sku === "Clear") {
    return window.GLASSON_CONFIG.STORAGE + "assets/red_cross.png";
  } else if (option.colors) {
    const colors = option.colors.split("|");
    return colors[0].split(",");
  }
};

const rgbToCSS = rgb => {
  return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
};

const rgbaToCSS = rgba => {
  return `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`;
};

const imageToBlob = url => {
  return new Promise((resolve, reject) => {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.onerror = () => {
        reject("Network error");
      };
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          reject("Loading error: " + xhr.statusText);
        }
      };
      xhr.send();
    } catch (err) {
      reject(err);
    }
  });
};

const createOrder = async (options, pd, thumb, orderId) => {
  const searchParams = new URLSearchParams(window.location.search);
  const body = {
    accountId: searchParams.get("accountId") || 3,
    pd,
    options: Object.values(options),
    ...(thumb && { thumb })
  };
  const res = await fetch(window.GLASSON_CONFIG.ENDPOINT + "Orders/create" + (orderId ? `?id=${orderId}` : ""), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body)
  });
  const order = await res.json();
  return order;
};

export { decideThumb, rgbToCSS, rgbaToCSS, imageToBlob, createOrder };
